import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateOneOneOne = ({
  titleText = "Choose your path",
  titleFont = "Roboto",
  titleFontSize = "32",
  titleColor = "#FFFFFF",
  titleTextAlign = "left",
  titleIsBold = false,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = false,

  subtitleText = "Pick what fits your goal today.",
  subtitleFont = "Roboto",
  subtitleFontSize = "18",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "center",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,
  subtitleBackgroundColor = "#000000",

  backgroundType = "color",
  backgroundColor = "#4A4A4A",
  backgroundImage = null,

  buttonLabel = "Learn more",
  buttonFont = "Helvetica",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#FF5722",

  // Secondary Button (Get Started)
  secondaryButtonLabel = "Get Started",
  secondaryButtonFont = "Segoe UI",
  secondaryButtonIsBold = false,
  secondaryButtonIsItalic = false,
  secondaryButtonIsUnderline = false,
  secondaryButtonLink = "",
  secondaryButtonFontSize = "16",
  secondaryButtonFontColor = "#FFFFFF",
  secondaryButtonBackgroundColor = "#00BCD4",

  backgroundImagePreview,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
      className={`relative ${
        !inmeeting
          ? "h-auto"
          : ["top", "bottom"].includes(position)
          ? "h-[150px]"
          : "!h-[89vh] mt-[5%]"
      } w-full flex items-center px-4 md:px-8 py-4 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container - Horizontal Layout */}
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between w-full max-w-7xl mx-auto gap-4 md:gap-8">
        {/* Main Heading - Left */}
        <div className="flex-shrink-0">
          <h1
            className={`${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } whitespace-nowrap`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              lineHeight: "1.2",
              textTransform: titleUppercase ? "uppercase" : "none",
            }}
          >
            {titleText}
          </h1>
        </div>

        {/* Subtitle with Background - Center */}
        <div
          className={`flex-shrink-0 px-1 py-1 rounded-md ${
            explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
          } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
            explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
          }`}
          style={{
            backgroundColor: subtitleBackgroundColor,
            color: subtitleColor,
            fontSize: `${subtitleFontSize}px`,
            fontFamily: subtitleFont,
            textAlign: subtitleTextAlign,
            whiteSpace: "pre-line",
          }}
        >
          {subtitleText}
        </div>

        {/* Buttons Container - Right */}
        <div className="flex flex-row gap-4 flex-shrink-0">
          {/* Primary Button (Learn more) */}
          <button
            className={`px-2 py-2 md:px-4 md:py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap ${
              buttonLink ? "cursor-pointer" : "cursor-default"
            } ${explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""} ${
              explicitBoleanCheck(buttonIsItalic) ? "italic" : ""
            } ${explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""}`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>

          {/* Secondary Button (Get Started) */}
          <button
            className={`px-2 py-2 md:px-4 md:py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap ${
              secondaryButtonLink ? "cursor-pointer" : "cursor-default"
            } ${
              explicitBoleanCheck(secondaryButtonIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(secondaryButtonIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(secondaryButtonIsUnderline) ? "underline" : ""
            }`}
            style={{
              backgroundColor: secondaryButtonBackgroundColor,
              color: secondaryButtonFontColor,
              fontSize: `${secondaryButtonFontSize}px`,
              fontFamily: secondaryButtonFont,
            }}
            onClick={() => {
              if (secondaryButtonLink) {
                window.open(secondaryButtonLink, "_blank");
              }
            }}
          >
            {secondaryButtonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HorizontalTemplateOneOneOne;
